import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;

// Components
export const fetchComponents = async (quotationId) => {
  const res = await axios.get(`${baseUrl}/quotation/components?QuotationID=${quotationId}`);
  return res.data;
};

export const createComponent = async ({ PackageID, ComponentType, DisplayOrder }) => {
  return axios.post(`${baseUrl}/quotation/components`, { PackageID, ComponentType, DisplayOrder });
};

export const updateComponent = async (compId, newName) => {
  return axios.put(`${baseUrl}/quotation/components/${compId}`, { ComponentType: newName });
};

export const deleteComponent = async (compId) => {
  return axios.delete(`${baseUrl}/quotation/components/${compId}`);
};

export const moveComponentUp = async (compId) => {
  return axios.post(`${baseUrl}/quotation/components/${compId}/move-up`);
};

export const moveComponentDown = async (compId) => {
  return axios.post(`${baseUrl}/quotation/components/${compId}/move-down`);
};

export const fetchPackageDetails = async (quotationId) => {
  const res = await axios.get(`${baseUrl}/quotation/packages/${quotationId}`);
  return res.data;
};

// Work Items
export const fetchWorkItems = async (componentId) => {
  const res = await axios.get(`${baseUrl}/quotation/workitems?componentId=${componentId}`);
  return res.data;
};

export const createWorkItem = async (newItem) => {
  return axios.post(`${baseUrl}/quotation/workitems`, newItem);
};

export const updateWorkItem = async (workItemId, itemData) => {
  return axios.put(`${baseUrl}/quotation/workitems/${workItemId}`, itemData);
};

export const deleteWorkItem = async (workItemId) => {
  return axios.delete(`${baseUrl}/quotation/workitems/${workItemId}`);
};

export const moveWorkItemUp = async (workItemId) => {
  return axios.post(`${baseUrl}/quotation/workitems/${workItemId}/move-up`);
};

export const moveWorkItemDown = async (workItemId) => {
  return axios.post(`${baseUrl}/quotation/workitems/${workItemId}/move-down`);
};

export const syncAllSrNo = async (componentId, srNoList) => {
  return axios.post(`${baseUrl}/quotation/workitems/sync-all-srno`, { componentId, srNoList });
};
